module.exports = __webpack_public_path__ + "static/media/atv-ride.56cb0658.jpg";